import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../components/CustomText";
import Color from "../../../utils/Color";
import "fontsource-muli";
import CustomTextInput from "../../components/CustomTextInput";
import CustomButton from "../../components/CustomButton";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as selector from "../../../common/selectors";
import * as forgotUserIdSelector from "../../../common/selectors/auth";
import * as forgotUserIdAction from "../../../common/actions/auth";
import CustomToast from "../../components/CustomToast";
import LoadingOverlay from "../../components/LoadingOverlay";
import AuthManager from "../../../utils/AuthManager";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { Popover } from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { format, parse, isValid, isBefore, subYears, isAfter } from 'date-fns';
import IconButton from '@material-ui/core/IconButton';
import calendar from '../../../assets/img/calendar.svg';
import CustomBoardNewLogin from "../../components/CustomBoardNewLogin";
import ForgotErrPop from "../OnboardingFlow/forgotErrPop";

const StyledTooltip = withStyles({
  tooltip: {
    color: Color.secondaryTextColor,
    backgroundColor: Color.backgroundColor,
    ...getFontWeight("normal"),
    ...getFontSize("small"),
  },
})(Tooltip);

const BlueOnGreenTooltip = withStyles({
  tooltip: {
    color: "#74788D",
    backgroundColor: "#FFEDB9",
    minWidth: "100px",

  },
  arrow: {
    fontSize: 10,
    width: "10px",
    color: "#FFEDB9",
    "&::before": {
      backgroundColor: "#FFEDB9",
      //border: "2px solid red"
    }
  }
})(Tooltip);

const BlueOnGreenTooltip2 = withStyles({
  tooltip: {
    color: "#74788D",
    backgroundColor: "#FFEDB9",
    //minWidth: "400px",

  }
})(Tooltip);

class ForgotUserID extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nric: "",
      dob: "",
      height: 0,
      width: 0,
      customToastStatus: false,
      toastMessage: "",
      forgotUserIdAction: false,
      open: false,
      isDOBValid: true,
      dobTouched: false,
      anchorEl: null,
      isVisiblePopUp:false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);


  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate() {
    const { forgotUserIdData, forgotUserIdLoading } = this.props;
    const IsSuccess = forgotUserIdSelector.getForgotUserIdResponseStatus(
      forgotUserIdData
    );
    const otpReference = forgotUserIdSelector.getForgotUserIdOtpReference(
      forgotUserIdData
    );

    const MobilePhoneLabel = forgotUserIdSelector.getForgotUserIdMobilePhoneLabel(
      forgotUserIdData
    );
    const getForgotUserIdDataMessage = forgotUserIdSelector.getForgotUserIdDataMessage(
      forgotUserIdData
    );

    if (
      this.state.forgotUserIdAction === true &&
      forgotUserIdLoading === false
    ) {
      if (IsSuccess === true && otpReference !== null) {
        const { history } = this.props;
        AuthManager.setNric(this.state.nric);
        AuthManager.setOtpReference(otpReference);
        AuthManager.setMobilePhoneLabel(MobilePhoneLabel);
        // history.push("/prototype/GetCurrentUserOTP", {
        //   nric: this.state.nric,
        //   otpReference,
        //   MobilePhoneLabel,
        // });
        history.push("/GetCurrentUserOTP");
      } else {
        const StatusCode = forgotUserIdSelector.getForgotUserIdStatusCode(
          forgotUserIdData
        );
        if (StatusCode === 1) {
          this.setState({ customToastStatus: false,isVisiblePopUp:true  });
          this.setState({
            //toastMessage: "Invalid Date of Birthday",
            toastMessage: getForgotUserIdDataMessage,
          });
        } else if (StatusCode === 2) {
          this.setState({ customToastStatus: false,isVisiblePopUp:true  });
          this.setState({
            toastMessage: getForgotUserIdDataMessage,
          });
        } else if (StatusCode === 3) {
          this.setState({ customToastStatus: false,isVisiblePopUp:true  });
          this.setState({
            //toastMessage: "No App ID",
            toastMessage: getForgotUserIdDataMessage,
          });
        } else if (StatusCode === 4) {
          this.setState({ customToastStatus: false,isVisiblePopUp:true  });
          this.setState({
            //toastMessage: "TwoFaDisabled",
            toastMessage: getForgotUserIdDataMessage,
          });
        } else if (StatusCode === 5) {
          this.setState({ customToastStatus: false,isVisiblePopUp:true  });
          this.setState({
            //toastMessage: "Cif Invalid",
            toastMessage: getForgotUserIdDataMessage,
          });
        } else if (StatusCode === 6) {
          this.setState({ customToastStatus: false,isVisiblePopUp:true });
          this.setState({
            //toastMessage: "No User ID",
            toastMessage: getForgotUserIdDataMessage,
          });
        } else if (StatusCode === 7) {
          this.setState({ customToastStatus: false,isVisiblePopUp:true });
          this.setState({
            //toastMessage: "Invalid Login Record",
            toastMessage: getForgotUserIdDataMessage,
          });
        } else {
          this.setState({ customToastStatus: false,isVisiblePopUp:true });
          this.setState({
            toastMessage:
              "Sorry, your request cannot be processed. Please WhatsApp our Customer Care at +65 6887 8777.",
          });
        }
      }
      this.setState({ forgotUserIdAction: false });
    }
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight, width: window.innerWidth });
  }

  onChangeNRIC = (event) => {
    this.setState({ nric: event.target.value });
  };

  handleDOBChange = (raw) => {
    let digits = raw.replace(/\D/g, '').slice(0, 8);
    let display = digits;

    if (digits.length >= 5) {
      display = digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4);
    } else if (digits.length >= 3) {
      display = digits.slice(0, 2) + '/' + digits.slice(2);
    }

    this.setState({ dobTouched: true, dob: display });

    if (digits.length === 8) {
      const dt = parse(display, 'dd/MM/yyyy', new Date());
      const today = new Date();
      const minDOB = subYears(today, 125);

      const valid = isValid(dt) && isBefore(dt, today) && isAfter(dt, minDOB);
      this.setState({ isDOBValid: valid });
    } else {
      this.setState({ isDOBValid: false });
    }
  };

  handleCalendarClick = (e) => {
    this.setState({ anchorEl: e.currentTarget });
  };

  handleClosePicker = () => {
    this.setState({ anchorEl: null });
  };

  handleDateChange = (date) => {
    if (!date) return;
    const newDate = format(date, 'dd/MM/yyyy');
    const oldDate = this.state.dob;

    this.setState({ dob: newDate, isDOBValid: isBefore(date, new Date()), dobTouched: true });

    if (oldDate) {
      const newDay = format(date, 'dd');
      const oldDay = format(parse(oldDate, 'dd/MM/yyyy', new Date()), 'dd');
      if (newDay !== oldDay) {
        this.handleClosePicker();
      }
    }
  };

  onClickNext = async () => {
    const { nric, dob, isDOBValid } = this.state;
    const { postForgotUserIdRequest } = this.props;
    if (nric === "" && dob === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "NRIC/Passport/FIN No. and Date of Birth cannot be empty",
      });
      return;
    }
    if (nric === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "NRIC/Passport/FIN No. cannot be empty",
      });
      return;
    }
    if (dob === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "Date of Birth cannot be empty",
      });
      return;
    }
    if (!isDOBValid) {
      this.setState({
        customToastStatus: true,
        toastMessage: "Invalid date or future date. Use DD/MM/YYYY."
      });
      return;
    }
    // proceed with API
    try {
      // Call reCAPTCHA API to get the token
      const recaptchaToken = await window.grecaptcha.execute(
        "6Lce7OMZAAAAALxOm9WwIETw1EL9UB73SDe4g0Tx",
        { action: "WEB_FORGOTUSERID" }
      );

      if (!recaptchaToken) {
        this.setState({
          //toastMessage: "User ID and Password can not be empty.",
          customToastStatus: true,
          toastMessage: "Unable to verify reCAPTCHA. Please try again.",
        });
        return;
      }
      const parsedDate = parse(dob, "dd/MM/yyyy", new Date());
      const formatted = format(parsedDate, "ddMMyyyy");
      postForgotUserIdRequest(nric, formatted, recaptchaToken);


    } catch (error) {
      this.setState({
        //toastMessage: "User ID and Password can not be empty.",
        customToastStatus: true,
        toastMessage: "Error during reCAPTCHA verification. Please try again.",
      });
    }

    this.setState({ forgotUserIdAction: true });
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

  onClickBack = () => {
    const { history } = this.props;
    history.push("/");
  };

  handleTooltipClose = () => {
    this.setState({ open: false });
  };

  handleTooltipOpen = () => {
    this.setState({ open: !this.state.open });
  };

  renderTooltip = (item) => {
    const { classes } = this.props;

    return (
      <ClickAwayListener onClickAway={this.handleTooltipClose}>
        <StyledTooltip
          disableFocusListener
          disableHoverListener
          disableTouchListener
          onClose={this.handleTooltipClose}
          open={this.state.open}
          title={
            <CustomText design={classes.tooltipTextStyle}>
              {<b>e.g </b>}S1234567A, F1234567A
            </CustomText>
          }
          placement="right"
        >
          <HelpIcon
            className={classes.infoIconStyleV2}
            onClick={this.handleTooltipOpen}
          />
        </StyledTooltip>
      </ClickAwayListener>
    );
  };

  renderTooltip1 = () => {
    const { classes } = this.props;
    if (window.innerWidth > 600) {
      return (
        <BlueOnGreenTooltip title={
          <CustomText design={classes.tooltipTextStyle1}>
            {<b>e.g </b>}S1234567A, F1234567A
          </CustomText>
        } placement="right" arrow>
          <HelpIcon className={classes.infoIconStyleV2} />
        </BlueOnGreenTooltip>

      );
    } else {
      return (
        <ClickAwayListener onClickAway={this.handleTooltipClose}>
          <BlueOnGreenTooltip2
            PopperProps={{
              disablePortal: true,
            }}
            onClose={this.handleTooltipClose}
            open={this.state.open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={
              <CustomText design={classes.tooltipTextStyle2}>
                {<b>e.g </b>}S1234567A, F1234567A
              </CustomText>
            }
            // placement={!matchesSM ? "right-start" : "bottom-end"}
            placement={"right"}
          >
            <HelpIcon
              className={classes.infoIconStyle}
              onClick={this.handleTooltipOpen}
            />
          </BlueOnGreenTooltip2>
        </ClickAwayListener>
      );
    }
  };

  renderChildren = () => {
    const { classes } = this.props;
    const { nric, dob } = this.state;
    return (
      <div className={classes.mainCon} style={{ width: '490px', marginLeft: '-3rem' }}>
        <CustomText design={classes.headerTextStyle}>Please provide your details</CustomText>
        <div className={classes.inputContainer}>
          <div>
            <CustomTextInput
              title={"NRIC/Passport/FIN No."}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={nric}
              onChange={this.onChangeNRIC}
              tooltip={this.renderTooltip1("nric")}
            />
          </div>

          <div style={{ marginTop: 25 }}>
            <CustomTextInput
              title={"Date of birth"}
              textstyle={(this.state.dobTouched && !this.state.isDOBValid) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={dob}
              placeholder={"DD/MM/YYYY"}
              onChange={(e) => this.handleDOBChange(e.target.value)}
              error={(this.state.dobTouched && !this.state.isDOBValid)}
              errorTextStyle={classes.errorTextStyle}
              errorMessage={!this.state.dob ? "Please enter your date of birth." : "Invalid date or future date. Use DD/MM/YYYY."}
              endAdornment={
                <IconButton onClick={this.handleCalendarClick}>
                  <img src={calendar} className={classes.infoIconStyle} />
                </IconButton>
              }
            />
            {this.state.anchorEl && (
              <Popover
                open={Boolean(this.state.anchorEl)}
                anchorEl={this.state.anchorEl}
                onClose={this.handleClosePicker}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <DatePicker
                  variant="static"
                  format="dd/MM/yyyy"
                  value={this.state.dob ? parse(this.state.dob, 'dd/MM/yyyy', new Date()) : null}
                  onChange={this.handleDateChange}
                  maxDate={new Date()}
                  minDate={new Date(1900, 0, 1)}
                />
              </Popover>
            )}
          </div>
        </div>
        <div style={{ paddingRight: '1em', width: '100%', marginTop: '2rem' }}>
          <CustomButton
            title={"Next"}
            design={classes.buttonStyle}
            onClick={this.onClickNext}
          />
        </div>
        <div className={classes.backButtonContainer}>
          <span className={classes.backButtonLink} onClick={this.onClickBack}>Back</span>
        </div>
      </div>
    );
  };

  render() {
    const { classes, forgotUserIdLoading } = this.props;
    const { height, width,isVisiblePopUp,toastMessage } = this.state;
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <CustomBoardNewLogin
          // maintenanceChild={<></>}
          children={this.renderChildren()}
          height={height}
          width={width}
        />
        <CustomToast
          open={this.state.customToastStatus}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />
        {forgotUserIdLoading ? <LoadingOverlay loading={true} /> : false}
        <ForgotErrPop isVisible={isVisiblePopUp} onClose={()=>{this.setState({isVisiblePopUp:false})}} msg={toastMessage}/>
        </MuiPickersUtilsProvider>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  headerTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
  },
  labelTextInputTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyleError: {
    fontWeight: 500,
    fontSize: 14,
    color: '#EF4444',
  },
  textInputContainer: {
    height: 40,
    marginTop: 5,
  },
  inputContainer: {
    marginTop: 40,
  },
  buttonStyle: {
    height: '47px',
    [theme.breakpoints.down('sm')]: {
      height: '45px',
    },
  },
  backButton: {
    width: 120,
    marginTop: 30,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  tooltipTextStyle: {
    color: "#74788D",
    backgroundColor: "#FFEDB9",
    ...getFontWeight("normal"),
    [theme.breakpoints.up("xs")]: {},
    [theme.breakpoints.up("lg")]: {
      width: 190,
      height: 18,
    },
  },
  infoIconStyle: {
    width: "20x",
    height: "20px",
    color: "#00B4AF",
    marginLeft: 10,
  },
  infoIconStyleV2: {
    width: "20x",
    height: "20px",
    color: "#FEC31A",
    marginLeft: 10,
  },
  tooltipTextStyle1: {
    color: "#74788D",
    //opacity: 0.45,
    fontSize: "12px",
    fontWeight: "400",
    padding: 2,
    lineHeight: 1.6,
    paddingLeft: 5
    //background:"red"

  },
  tooltipTextStyle2: {
    color: "#74788D",
    //opacity: 0.45,
    fontSize: "12px",
    fontWeight: "400",
    //padding:2,
    //lineHeight:1.6,
    //paddingLeft:5
    //background:"red"

  },
  errorTextStyle: {
    // marginTop:'-1.2rem'
  },
  backButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: '1.5rem',
    color: '#0D99FF',
  },
  backButtonLink: {
    cursor: 'pointer',
  },
  mainCon:{
    [theme.breakpoints.down('sm')]: {
     width:"90% !important",
     margin:"auto !important"
    }
  }
});

function mapStateToProps(state) {
  return {
    forgotUserIdData: selector.getForgotUserIdData(state),
    forgotUserIdLoading: selector.getForgotUserIdLoading(state),
    forgotUserIdStatus: selector.getForgotUserIdStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    postForgotUserIdRequest: (userID, birthdate, recaptchaToken) =>
      dispatch(forgotUserIdAction.postForgotUserIdRequest(userID, birthdate, recaptchaToken)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(ForgotUserID)));

